import React, { useState, useEffect, useRef } from "react"

import Results from "./Results"
import Input from "./Input"
import Filter from "./Filter"

import * as style from "./Search.module.scss"

const FOCUSED_ELEMENT = {
  INPUT: 0,
  RESULTS: 1,
  FILTER: 2,
}

const KEY_CODES = {
  TAB: 9,
  ARROW_DOWN: 40,
  ARROW_UP: 38,
  ENTER: 13,
}

const Search = ({ engine, microcopy }) => {
  const backdrop = useRef()
  const inputRef = useRef(null)

  const [focused, setFocused] = useState(FOCUSED_ELEMENT.INPUT)

  const onInputFocus = () => {
    setFocused(FOCUSED_ELEMENT.INPUT)
  }

  useEffect(() => {
    if (focused !== FOCUSED_ELEMENT.INPUT) {
      inputRef?.current?.blur()
      engine.onResultFocusChange(true)
    } else {
      inputRef?.current?.focus()
      engine.onResultFocusChange(false)
    }
  }, [focused, inputRef])

  useEffect(() => {
    const downHandler = (event) => {
      const isAnyResult = !!engine.state.results?.[0]
      if (event.keyCode === KEY_CODES.TAB) {
        event.preventDefault()
        setFocused((focused + 1) % 2)
      } else if (focused === FOCUSED_ELEMENT.INPUT && event.keyCode === KEY_CODES.ARROW_DOWN && isAnyResult) {
        const input = event.target
        const isCaretAtEnd = input.selectionStart === input.value.length && input.selectionEnd === input.value.length
        if (isCaretAtEnd) {
          event.preventDefault()
          setFocused(FOCUSED_ELEMENT.RESULTS)
        }
      } else if (focused === FOCUSED_ELEMENT.RESULTS) {
        if (event.keyCode === KEY_CODES.ARROW_UP && engine.getSelectedItemIndex() === 0) {
          event.preventDefault()
          setFocused(FOCUSED_ELEMENT.INPUT)
        } else if (event.keyCode === KEY_CODES.ARROW_DOWN || event.keyCode === KEY_CODES.ARROW_UP) {
          event.preventDefault()
          engine.keyup(event)
        } else if (event.keyCode === KEY_CODES.ENTER) {
          event.preventDefault()
          engine.keyup(event)
        }
      }
    }

    window.addEventListener('keydown', downHandler)

    return () => {
      window.removeEventListener('keydown', downHandler)
    }
  }, [engine, focused, inputRef])

  return (
    <div
      className={style.backdrop}
      data-visible={engine.state.showSearch}
      onClick={(e) => e.target === backdrop.current && engine.hide(0)}
      ref={backdrop}
    >
      <div className={style.search} data-visible={engine.state.showSearch}>
        <Input engine={engine} microcopy={microcopy} inputRef={inputRef} onFocus={onInputFocus} />
        <Filter engine={engine} microcopy={microcopy} />
        <Results engine={engine} microcopy={microcopy} focused={focused === FOCUSED_ELEMENT.RESULTS} />
      </div>
    </div>
  )
}

export default Search
